import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {Grid} from "@mui/material";

// Components
import CustomButton from "components/CustomButton";
import Popup from "components/WMS/Mobile/Popup";

// Local Components
import TrackingNumber from "../../../components/TrackingNumberBlue";

// Assets
import {ReactComponent as ScanIcon} from "assets/img/wms/scan.svg"
import {black500} from "assets/jss/main";

// Context
import {ClickAndCollectHandOverContext} from "../../context/ClickAndCollectHandOverContext";
import Containers from "../../../components/Containers";

HandOverScanShipmentPopup.propTypes = {
    onClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

function HandOverScanShipmentPopup({onClick = () => {}, onClose = () => {}}) {
    const {selectedShipment} = useContext(ClickAndCollectHandOverContext);

    return (
        <Popup
            title={<FormattedMessage id={'wms.cc.handover.handoverScanShipment.popup.title'} />}
            subtitle={<FormattedMessage id={'wms.cc.handover.handoverScanShipment.popup.subtitle'} />}
            open={selectedShipment !== null}
            icon={<ScanIcon />}
            isMobile={true}
            onClose={onClose}
        >
            <Grid container>
                <Grid item xs={12}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'center'
                        }}
                    >
                        <TrackingNumber trackingNumber={selectedShipment.trackingNumber ?? selectedShipment.externalDeliveryNumber} />
                        <b style={{ fontSize: '20px', color: black500 }}>
                            {selectedShipment.order.customerShippingFirstname} &nbsp;
                            {selectedShipment.order.customerShippingLastname}
                        </b>
                        <div>
                            <Containers shipment={selectedShipment} />
                        </div>
                    </div>
                </Grid>
                <Grid
                    item
                    container
                    direction={'column'}
                    spacing={2}
                    marginTop={4}
                >
                    <Grid item>
                        <CustomButton
                            fullWidth={true}
                            thicker={true}
                            color={'blue'}
                            onClick={onClick}
                        >
                            <FormattedMessage id={'wms.cc.handover.handoverScanShipment.popup.action.validate'} />
                        </CustomButton>
                    </Grid>
                    <Grid item>
                        <CustomButton
                            onClick={onClose}
                            fullWidth={true}
                            thicker={true}
                            color={'default'}
                        >
                            <FormattedMessage id={'wms.cc.handover.handoverScanShipment.popup.action.cancel'} />
                        </CustomButton>
                    </Grid>
                </Grid>
            </Grid>
        </Popup>
    );
}

export default HandOverScanShipmentPopup;
